export const titles = {
  REJECT_APPOINTMENT: "reject appointment",
  CANCEL_APPOINTMENT: "cancel appointment",
}

export const btnText = {
  REJECT_APPOINTMENT: "Reject",
  CANCEL_APPOINTMENT: "Cancel",
}

export const messages = {
  REJECT_APPOINTMENT: "Enter a valid reason for rejecting this appointment.",
  CANCEL_APPOINTMENT: "Enter a valid reason for cancel this appointment.",
}